import { SpringRestConfig } from "../SpringRestConfig";
import { BaseRestApi, TRestErrorHandler, RestResponse } from "@oceanjs/core";
import { ImportProtokoll } from "../model";



const resource = SpringRestConfig.services.excel;


class ExcelServiceApiImpl extends BaseRestApi {


  public async uploadExcelFile(file: File, email: string, onError?: TRestErrorHandler): Promise<RestResponse<ImportProtokoll>> {

    const config = { headers: {'Content-Type': 'multipart/form-data'}};
    const data = new FormData();
    data.append('file', file);
    const result = await this.postCustomEndpoint<ImportProtokoll,FormData>(`upload`, data, {email}, onError, config);

    return result;
  }

  public async getExcelFile(id: number, onError?: TRestErrorHandler): Promise<any> {

    const result = await this.getCustomEndpoint(`upload/datei/${id}`,undefined, onError, { responseType: 'arraybuffer' });
    return result;

  }

  public async getExcelFileProtocol(id: number, onError?: TRestErrorHandler): Promise<any> {

    const result = await this.getCustomEndpoint(`upload/protokoll/${id}`,undefined, onError, { responseType: 'arraybuffer' });
    return result;
  }

  public async getExcelExport(onError?: TRestErrorHandler): Promise<any> {
    const result = await this.getCustomEndpoint(`download`,undefined, onError, { responseType: 'arraybuffer' });
    return result;
  }

}

export const ExcelServiceApi = new ExcelServiceApiImpl(resource);
